var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nav',{staticClass:"wws-stepper",attrs:{"role":"progressbar","aria-label":`Step ${_setup.activeStep + 1} of ${_setup.steps}`,"aria-valuemin":1,"aria-valuemax":_setup.steps,"aria-valuenow":_setup.activeStep + 1,"data-testid":"welcome-wizard-stepper"}},_vm._l((_setup.steps),function(index){return _c('span',{key:index,staticClass:"wws-segment",class:{
      'wws-segment--filled': index - 1 <= _setup.activeStep,
      'wws-segment--current': index - 1 === _setup.activeStep,
    },attrs:{"aria-hidden":true,"data-testid":`wws-segment-${index - 1}`}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }